var $videos = {
  play: function(video) {
    // console.log('video - play');
    video.get(0).play();
  },

  pause: function(video) {
    // console.log('video - pause');
    video.get(0).pause();
  },

  pauseAll: function(id) {
    // console.log('video - pause all');
    $('video').each(function() {
      $(this)
        .get(0)
        .pause();
    });
  }
};
